import TextUtil from "../../../../../lib/html5-software-library/src/ranj/components/text/TextUtil";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import HubEvent from "../../hub/event/HubEvent";
import KeyDecisionInteractionEvent from "../event/KeyDecisionInteractionEvent";
import KeyDecision from "../model/KeyDecision";

export default class KeyDecisionAvailableScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory
     * @param {RevisableLanguagePack} languagePack
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;

        this._transitionInDuration = this.getCustomData().transitionInDuration || 0;
        /** @type {KeyDecision} */
        this._keyDecision = this.getCustomData().keyDecision;
    }

    initialize() {
        super.initialize();

        this.preventClickThrough();

        this._target.panel.headerTextField.text = this._languagePack.getText('keyDecisionInterface.newKeyDecisionPopup.title');
        this._target.panel.descriptionTextField.text = this._languagePack.getText(this._keyDecision.descriptionLpKey);
        this._target.panel.disclaimerTextField.text = this._languagePack.getText('keyDecisionInterface.newKeyDecisionPopup.disclaimer');

        this._target.panel.keyDecisionTextfield.initialY = this._target.panel.keyDecisionTextfield.y;
        this._target.panel.keyDecisionTextfield.initialBounds = this._target.panel.keyDecisionTextfield.getBounds();
        this._target.panel.keyDecisionTextfield.text = this._languagePack.getText(this._keyDecision.actionNeededLpKey);
        TextUtil.centerTextVertically(this._target.panel.keyDecisionTextfield, this._target.panel.keyDecisionTextfield.initialY, this._target.panel.keyDecisionTextfield.initialBounds.height);

        this._continueButton = this.createButton(this._target.panel.continueButton, this._handleContinueButton.bind(this), this._languagePack.getText('keyDecisionInterface.newKeyDecisionPopup.continueButtonLabel'));
        this._backButton = this.createButton(this._target.panel.KDbackButton, this._handleBackButton.bind(this), this._languagePack.getText('keyDecisionInterface.newKeyDecisionPopup.backButtonLabel'));

        this._target.panel.continueButton.alpha = 0;
        this._target.panel.continueButton.scale = 0.8;
        this._target.panel.KDbackButton.alpha = 0;
        this._target.panel.KDbackButton.scale = 0.8;
        this._target.panel.disclaimerTextField.alpha = 0;
        this._target.panel.disclaimerTextField.scale = 0.8;
        this._target.overlay.alpha = 0;

        this._animIn();
    }

    destroy() {
        super.destroy();
    }

    _handleBackButton() {
        this.disableInteraction();
        this.dispatch(HubEvent.UNSELECT_KEY_DECISION_LIST_ITEM);
        this.closePopup(this._target);
    }

    _handleContinueButton() {
        this.disableInteraction();
        this.dispatch(HubEvent.UNSELECT_KEY_DECISION_LIST_ITEM);
        const confirmDecisionSeenEvent = new KeyDecisionInteractionEvent(KeyDecisionInteractionEvent.REQUEST_KEY_DECISION, this._keyDecision);
        this.dispatch(confirmDecisionSeenEvent.type, { data: confirmDecisionSeenEvent });
        this.closePopup(this._target);
    }

    _animIn() {
        this._target.panel.alpha = 0;
        this._target.panel.scale = 0;

        createjs.Tween.get(this._target.panel)
            .wait(this._transitionInDuration)
            .to({ alpha: 1, scale: 1 }, 450, createjs.Ease.backOut);

        createjs.Tween.get(this._target.panel.continueButton)
            .wait(this._transitionInDuration + 1150)
            .to({ alpha: 1, scale: 1 }, 450, createjs.Ease.backOut);

        createjs.Tween.get(this._target.panel.KDbackButton)
            .wait(this._transitionInDuration + 1150)
            .to({ alpha: 1, scale: 1 }, 450, createjs.Ease.backOut);

        createjs.Tween.get(this._target.panel.disclaimerTextField)
            .wait(this._transitionInDuration + 1150)
            .to({ alpha: 1, scale: 1 }, 450, createjs.Ease.backOut);
    }
}